import { appendLog } from './services/frontendLogger';

const DEBUG = true; // set false to silence debug-level logs

const prefix = (level) => `[App:${level}]`;

// Remote echo (dev only) disabled to prevent 405 errors
const ENABLE_REMOTE_ECHO = false; // changed from dynamic
const QUEUE = [];
let flushTimer = null;

function scheduleFlush() {
  if (flushTimer || !ENABLE_REMOTE_ECHO) return;
  flushTimer = setTimeout(() => {
    const batch = QUEUE.splice(0, QUEUE.length);
    flushTimer = null;
    batch.forEach(entry => {
      // Encode message; keep it short to avoid very long URLs
      const truncated = entry.msg.length > 500 ? entry.msg.slice(0, 500) + '…' : entry.msg;
      const url = `/__clientlog?lvl=${entry.level}&t=${entry.t}&m=${encodeURIComponent(truncated)}`;
      // Fire-and-forget; dev server will log the request line (captured by nohup)
      try { fetch(url, { method: 'GET', cache: 'no-store' }).catch(() => {}); } catch {}
    });
  }, 1500); // batch every 1.5s
}

function echo(level, parts) {
  if (!ENABLE_REMOTE_ECHO) return;
  const msg = parts.map(p => {
    if (p instanceof Error) return `${p.name}: ${p.message}`;
    if (typeof p === 'object') {
      try { return JSON.stringify(p); } catch { return String(p); }
    }
    return String(p);
  }).join(' ');
  QUEUE.push({ level, msg, t: Date.now() });
  scheduleFlush();
}

export const logger = {
  debug: (...args) => {
    if (DEBUG) {
      console.debug(prefix('debug'), ...args);
      echo('debug', args);
      appendLog('debug', args.map(a => (a instanceof Error ? a.message : String(a))).join(' '));
    }
  },
  info: (...args) => {
    console.log(prefix('info'), ...args);
    echo('info', args);
    appendLog('info', args.map(a => (a instanceof Error ? a.message : String(a))).join(' '));
  },
  warn: (...args) => {
    console.warn(prefix('warn'), ...args);
    echo('warn', args);
    appendLog('warn', args.map(a => (a instanceof Error ? a.message : String(a))).join(' '));
  },
  error: (...args) => {
    console.error(prefix('error'), ...args);
    echo('error', args);
    appendLog('error', args.map(a => (a instanceof Error ? a.stack || a.message : String(a))).join(' '));
  }
};

export default logger;
